import { getLocalToken } from "./Common";
import Cookies from "js-cookie";

export const getCookies = () => {
  const callToken = Cookies.get("call_token");
  return callToken ? callToken : getLocalToken();
};
